import { useTranslation } from "react-i18next"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"

interface Template {
  idfTemplate: number
  reportType: string
  name: string
}

interface Props {
  open: boolean
  onClose: () => void
  templates: Template[]
}

export default function CannotDeleteDialog({ open, onClose, templates }: Props) {
  const { t } = useTranslation()

  const getReportTypeLabel = (reportType: string) => {
    if (reportType === "daily") return t("dailyReport")
    if (reportType === "trend") return t("trendReport")
    return reportType
  }

  return (
    <Dialog
      title={t("cannotDeleteMetric")}
      open={open}
      onClose={onClose}
      maxWidth="600px"
      footer={
        <BasicButton type="default-outlined" size="md" onClick={onClose}>
          {t("button.close")}
        </BasicButton>
      }>
      <div className="cannot-delete-content">
        <p>{t("messages.cannotDeleteMetric", { count: templates.length })}</p>
        <div className="template-list">
          {templates.map((template) => (
            <div key={template.idfTemplate} className="template-item">
              {getReportTypeLabel(template.reportType)} &gt; {template.name}
            </div>
          ))}
        </div>
      </div>
    </Dialog>
  )
}
